export default __webpack_public_path__ + "static/media/placeholder_her.fae838d6.png";